import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type CreateDimensionOptionPayload = {
	categoryDimensionUid: string;
	sequence: number;
	isTextbox: boolean;
	localizations: {
		"en-us": string;
		"de-ch": string;
		"de-de": string;
		"fr-fr": string;
		"it-it": string;
	};
};

const createDimensionOption = async (payload: CreateDimensionOptionPayload): Promise<any> => {
	const response = await apiDal.post("/categorydimensionoptions/create", payload);
	return response.data;
};

export const useCreateDimensionOption = () => {
	return useMutation({
		mutationFn: createDimensionOption,
	});
};
